import {Component, inject, Input, OnInit} from "@angular/core";
import { SearchContainer } from "src/app/core/definitions/search-container";
import {ModelStore} from "../../core/model-store/model-store";
import {ReportUserGenerated} from "../../core/model-store/models/report-user-generated";
import {Router} from "@angular/router";
import {ReportViewType} from "../../core/model-store/models/report-view-type";

@Component({
    selector: 'new-report-sidemenu',
    templateUrl: './new-report-sidemenu.html',
    styleUrls: ['./new-report-sidemenu.scss'],
    standalone: false
})
export class NewReportSidemenu implements OnInit {
  // Injections
  private readonly modelStore: ModelStore = inject(ModelStore);
  private readonly router: Router = inject(Router);

  @Input() searchContainer!: SearchContainer;
  @Input() newReportObject: any;
  newReport: ReportUserGenerated;
  reportViewTypes: ReportViewType[];
  newReportNameError: string = null;
  newReportShortDescriptionError: string = null;
  newReportViewTypeError: string = null;

  async validateForm() {
    this.newReportNameError = this.newReport.name?.length > 0 ? null : 'TRANS__REPORTS_V2_CREATE_REPORT_NAME_ERROR';
    this.newReportViewTypeError = this.newReport.reportViewTypeId ? null : 'TRANS__REPORTS_V2_CREATE_REPORT_VIEW_ERROR';

    console.log('errors? ', this.newReportNameError, this.newReportShortDescriptionError, this.newReportViewTypeError)
    if (this.newReportNameError || this.newReportShortDescriptionError || this.newReportViewTypeError) {
      return false;
    }

    await this.createReportAndForward();
  }

  async createReportAndForward() {
    this.newReport.artifactList = [];

    if (this.newReportObject?.()) {
      console.log(this.newReportObject());
      this.newReport.artifactList.push(this.newReportObject());
    } else if (this.searchContainer) {
      this.searchContainer.selections.selectedItems.forEach(item => {
        this.newReport.artifactList.push({ artifact_id: item.artifact_id, superobject_type_id: item.superobject_type_id, object_type: item.object_type });
      });
    }

    this.newReport.reportType = 'custom_user_report';

    let response = this.modelStore.createModel({modelSingularKey: 'report_user_generated',  record: this.newReport});
    await response.loading;
    await this.router.navigate(['/reports/generated-reports', response.id]);
  }

  ngOnInit() {
    this.asyncInit().then()
  }

  async asyncInit() {
    this.newReport = new ReportUserGenerated();
    this.reportViewTypes = this.modelStore.findAllModels('report_view_type');
    // @ts-ignore
    await this.reportViewTypes.loading;
  }

  reportViewTypeChanged() {
    console.log('reportViewTypeChanged', this.newReport.reportViewTypeId);
  }

  cancelNewReport() {
    //@if(searchContainer.operationContainer?.currentOperation?.$$currentStep?.operation_step_type == 'create_new_report')
    if (this.searchContainer) {
      this.searchContainer.operationContainer.currentOperation.$$currentStep.operation_step_type = null;
    }
  }
}
